import React from 'react';
import {
  Grid, Typography, Button, MenuItem, Checkbox, FormControlLabel, useMediaQuery, useTheme
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import DropdownWithIcon from './DropdownWithIcon';
import hospitalIcon from '../assets/protocols/hospital.svg';
import departmentIcon from '../assets/protocols/department.svg';
import roleIcon from '../assets/users/role.svg';

const PermissionsManager = ({
  roles, 
  hospitals, 
  loggedInSuperAdmin,
 isSuperAdmin,
 onChangeSuperAdmin,
 onRoleChange,
 onAddRole,
 onRemoveRole
}) => {
 const singleHospital = hospitals.length === 1 ? hospitals[0] : null;
 const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid item xs={12}>
        {loggedInSuperAdmin && (
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox                
                checked={isSuperAdmin}
                onChange={(e) => onChangeSuperAdmin(e.target.checked)}
                name="isSuperAdmin"
              />
            }
            label="מנהל על"
          />
        </Grid>
      )}
      <Typography variant="h6">הרשאות:</Typography>
      {roles?.map((role, index) => (
        <Grid container spacing={2} key={index} alignItems="center" style={{ marginBottom: '10px' }}>
          <Grid item xs={12} sm={4}>
            <DropdownWithIcon
              icon={hospitalIcon}
              placeholder="בית חולים"
              value={role.hospital?._id || role.hospital || ''}
              onChange={(e) => {
                onRoleChange(index, e.target.value, null, role.role);
              }}
              required
              disabled={isSuperAdmin || singleHospital}
            >
              {singleHospital ? (
                <option value={singleHospital._id}>{singleHospital.nameHebrew}</option>
              ) : (
                <>                  
                  {hospitals.map(hospital => (
                    <option key={hospital._id} value={hospital._id}>{hospital.nameHebrew}</option>
                  ))}
                </>
              )}
            </DropdownWithIcon>
          </Grid>
          <Grid item xs={12} sm={4}>
            <DropdownWithIcon
              icon={departmentIcon}
              placeholder="מחלקה"
              value={role.department?._id || role.department || ''}
              onChange={(e) => {
                const hospitalId = role.hospital?._id || role.hospital;
                const hospital = hospitals.find(h => h._id === hospitalId);
                const department = hospital?.departments.find(d => d._id === e.target.value);
                onRoleChange(index, role.hospital, department, role.role);
              }}
              required
              disabled={isSuperAdmin || !(role.hospital?._id || role.hospital)}
            >
              {(role.hospital?._id || role.hospital) && hospitals.find(h => h._id === (role.hospital?._id || role.hospital))?.departments.map(department => (
                <option key={department._id} value={department._id}>{department.nameHebrew}</option>
              ))}
            </DropdownWithIcon>
          </Grid>
          <Grid item xs={12} sm={3}>
            <DropdownWithIcon
              icon={roleIcon}
              placeholder="תפקיד"
              value={role.role}
              onChange={(e) => {
                onRoleChange(index, role.hospital, role.department, e.target.value);
              }}
              required
              disabled={isSuperAdmin}
            >
              <option value="USER">משתמש</option>
              <option value="EDITOR">עורך</option>
              <option value="ADMIN">מנהל</option>
            </DropdownWithIcon>
          </Grid>
          <Grid item xs={12} sm={1} style={{ textAlign: 'right' }}>
            <Button
              onClick={() => onRemoveRole(index)}
              variant="contained"
              style={{
                backgroundColor: isSuperAdmin ? '#B9EDE7' : '#1FB5A3',
                color: isSuperAdmin ? 'rgba(0, 0, 0, 0.26)' : 'white',
                minWidth: 'auto',
                width: isMobile ? '40px' : 'auto',
                height: '56px',
                padding: isMobile ? '0' : '6px 16px',
              }}
              disabled={isSuperAdmin}
            >
              <FontAwesomeIcon icon={faTrash} /> {!isMobile && 'הסר'}
            </Button>
          </Grid>
        </Grid>
      ))}
      <Button
        onClick={onAddRole}
        variant="contained"
        style={{ 
          backgroundColor: isSuperAdmin ? '#B9EDE7' : '#1FB5A3', 
          color: isSuperAdmin ? 'rgba(0, 0, 0, 0.26)' : 'white',
          marginTop: '10px' 
        }}
        disabled={isSuperAdmin}
      >
        <FontAwesomeIcon icon={faPlus} /> הוסף הרשאה
      </Button>
    </Grid>
  );
};

export default PermissionsManager;